// ─────────────────────────────────────────────────────────────────────────────
//  AUTO-GENERATED by tools/generate-catalog-art.mjs — do not edit by hand.
//  Run `node tools/generate-catalog-art.mjs` to regenerate.
// ─────────────────────────────────────────────────────────────────────────────

import vacuumPump1 from "./products/vacuum-pump-1.svg";
import vacuumPump2 from "./products/vacuum-pump-2.svg";
import vacuumPump3 from "./products/vacuum-pump-3.svg";
import manifoldGauge1 from "./products/manifold-gauge-1.svg";
import manifoldGauge2 from "./products/manifold-gauge-2.svg";
import manifoldGauge3 from "./products/manifold-gauge-3.svg";
import digitalMultimeter1 from "./products/digital-multimeter-1.svg";
import digitalMultimeter2 from "./products/digital-multimeter-2.svg";
import digitalMultimeter3 from "./products/digital-multimeter-3.svg";
import leakDetector1 from "./products/leak-detector-1.svg";
import leakDetector2 from "./products/leak-detector-2.svg";
import leakDetector3 from "./products/leak-detector-3.svg";
import recoveryMachine1 from "./products/recovery-machine-1.svg";
import recoveryMachine2 from "./products/recovery-machine-2.svg";
import recoveryMachine3 from "./products/recovery-machine-3.svg";
import tubeCutter1 from "./products/tube-cutter-1.svg";
import tubeCutter2 from "./products/tube-cutter-2.svg";
import tubeCutter3 from "./products/tube-cutter-3.svg";
import tubeBender1 from "./products/tube-bender-1.svg";
import tubeBender2 from "./products/tube-bender-2.svg";
import tubeBender3 from "./products/tube-bender-3.svg";
import multiBitScrewdriver1 from "./products/multi-bit-screwdriver-1.svg";
import multiBitScrewdriver2 from "./products/multi-bit-screwdriver-2.svg";
import multiBitScrewdriver3 from "./products/multi-bit-screwdriver-3.svg";
import jetPump1 from "./products/jet-pump-1.svg";
import jetPump2 from "./products/jet-pump-2.svg";
import jetPump3 from "./products/jet-pump-3.svg";
import drillMachine1 from "./products/drill-machine-1.svg";
import drillMachine2 from "./products/drill-machine-2.svg";
import drillMachine3 from "./products/drill-machine-3.svg";
import copperTubeCoil1 from "./products/copper-tube-coil-1.svg";
import copperTubeCoil2 from "./products/copper-tube-coil-2.svg";
import copperTubeCoil3 from "./products/copper-tube-coil-3.svg";
import copperStraightPipe1 from "./products/copper-straight-pipe-1.svg";
import copperStraightPipe2 from "./products/copper-straight-pipe-2.svg";
import copperStraightPipe3 from "./products/copper-straight-pipe-3.svg";
import gasR221 from "./products/gas-r22-1.svg";
import gasR222 from "./products/gas-r22-2.svg";
import gasR223 from "./products/gas-r22-3.svg";
import gasR134a1 from "./products/gas-r134a-1.svg";
import gasR134a2 from "./products/gas-r134a-2.svg";
import gasR134a3 from "./products/gas-r134a-3.svg";
import gasR321 from "./products/gas-r32-1.svg";
import gasR322 from "./products/gas-r32-2.svg";
import gasR323 from "./products/gas-r32-3.svg";
import gasR410a1 from "./products/gas-r410a-1.svg";
import gasR410a2 from "./products/gas-r410a-2.svg";
import gasR410a3 from "./products/gas-r410a-3.svg";
import gasR407a1 from "./products/gas-r407a-1.svg";
import gasR407a2 from "./products/gas-r407a-2.svg";
import gasR407a3 from "./products/gas-r407a-3.svg";
import gasR124a1 from "./products/gas-r124a-1.svg";
import gasR124a2 from "./products/gas-r124a-2.svg";
import gasR124a3 from "./products/gas-r124a-3.svg";
import gasR227ea1 from "./products/gas-r227ea-1.svg";
import gasR227ea2 from "./products/gas-r227ea-2.svg";
import gasR227ea3 from "./products/gas-r227ea-3.svg";
import canR2901 from "./products/can-r290-1.svg";
import canR2902 from "./products/can-r290-2.svg";
import canR2903 from "./products/can-r290-3.svg";
import canR6001 from "./products/can-r600-1.svg";
import canR6002 from "./products/can-r600-2.svg";
import canR6003 from "./products/can-r600-3.svg";
import canR134a1 from "./products/can-r134a-1.svg";
import canR134a2 from "./products/can-r134a-2.svg";
import canR134a3 from "./products/can-r134a-3.svg";
import canR221 from "./products/can-r22-1.svg";
import canR222 from "./products/can-r22-2.svg";
import canR223 from "./products/can-r22-3.svg";
import stabilizer1kva1 from "./products/stabilizer-1kva-1.svg";
import stabilizer1kva2 from "./products/stabilizer-1kva-2.svg";
import stabilizer1kva3 from "./products/stabilizer-1kva-3.svg";
import stabilizer3kva1 from "./products/stabilizer-3kva-1.svg";
import stabilizer3kva2 from "./products/stabilizer-3kva-2.svg";
import stabilizer3kva3 from "./products/stabilizer-3kva-3.svg";
import stabilizer5kva1 from "./products/stabilizer-5kva-1.svg";
import stabilizer5kva2 from "./products/stabilizer-5kva-2.svg";
import stabilizer5kva3 from "./products/stabilizer-5kva-3.svg";
import compressorRotary1 from "./products/compressor-rotary-1.svg";
import compressorRotary2 from "./products/compressor-rotary-2.svg";
import compressorRotary3 from "./products/compressor-rotary-3.svg";
import compressorScroll1 from "./products/compressor-scroll-1.svg";
import compressorScroll2 from "./products/compressor-scroll-2.svg";
import compressorScroll3 from "./products/compressor-scroll-3.svg";
import compressorRecip1 from "./products/compressor-recip-1.svg";
import compressorRecip2 from "./products/compressor-recip-2.svg";
import compressorRecip3 from "./products/compressor-recip-3.svg";
import indoorUnit1 from "./products/indoor-unit-1.svg";
import indoorUnit2 from "./products/indoor-unit-2.svg";
import indoorUnit3 from "./products/indoor-unit-3.svg";
import outdoorUnit1 from "./products/outdoor-unit-1.svg";
import outdoorUnit2 from "./products/outdoor-unit-2.svg";
import outdoorUnit3 from "./products/outdoor-unit-3.svg";
import brandCamipro from "./brands/camipro.svg";
import brandMpcl from "./brands/mpcl.svg";
import brandFloron from "./brands/floron.svg";
import brandSrf from "./brands/srf.svg";
import brandValue from "./brands/value.svg";
import brandGodrej from "./brands/godrej.svg";
import brandCopeland from "./brands/copeland.svg";
import brandVoltas from "./brands/voltas.svg";
import brandBluestar from "./brands/bluestar.svg";
import brandAdn from "./brands/adn.svg";
import brandGalaxy from "./brands/galaxy.svg";
import brandBtali from "./brands/btali.svg";
import brandXtraPower from "./brands/xtra-power.svg";
import brandSuntop from "./brands/suntop.svg";
import brandBrassBliz from "./brands/brass-bliz.svg";
import brandStallion from "./brands/stallion.svg";
import brandLg from "./brands/lg.svg";
import brandWhirlpool from "./brands/whirlpool.svg";
import brandIndigo from "./brands/indigo.svg";
import brandMicrotek from "./brands/microtek.svg";
import brandTaparia from "./brands/taparia.svg";
import brandMultitech from "./brands/multitech.svg";
import brandBosch from "./brands/bosch.svg";
import brandRalliWolf from "./brands/ralli-wolf.svg";
import brandHtc from "./brands/htc.svg";
import customerJindalSteel from "./customers/jindal-steel.svg";
import customerJindalPower from "./customers/jindal-power.svg";
import customerJindalIndiaPower from "./customers/jindal-india-power.svg";
import customerGmr from "./customers/gmr.svg";
import customerJsw from "./customers/jsw.svg";
import customerGeNtpc from "./customers/ge-ntpc.svg";
import customerTefelab from "./customers/tefelab.svg";

// slug → [studio view, contrast view, technical view]
export const productArt = {
  "vacuum-pump": [vacuumPump1, vacuumPump2, vacuumPump3],
  "manifold-gauge": [manifoldGauge1, manifoldGauge2, manifoldGauge3],
  "digital-multimeter": [digitalMultimeter1, digitalMultimeter2, digitalMultimeter3],
  "leak-detector": [leakDetector1, leakDetector2, leakDetector3],
  "recovery-machine": [recoveryMachine1, recoveryMachine2, recoveryMachine3],
  "tube-cutter": [tubeCutter1, tubeCutter2, tubeCutter3],
  "tube-bender": [tubeBender1, tubeBender2, tubeBender3],
  "multi-bit-screwdriver": [multiBitScrewdriver1, multiBitScrewdriver2, multiBitScrewdriver3],
  "jet-pump": [jetPump1, jetPump2, jetPump3],
  "drill-machine": [drillMachine1, drillMachine2, drillMachine3],
  "copper-tube-coil": [copperTubeCoil1, copperTubeCoil2, copperTubeCoil3],
  "copper-straight-pipe": [copperStraightPipe1, copperStraightPipe2, copperStraightPipe3],
  "gas-r22": [gasR221, gasR222, gasR223],
  "gas-r134a": [gasR134a1, gasR134a2, gasR134a3],
  "gas-r32": [gasR321, gasR322, gasR323],
  "gas-r410a": [gasR410a1, gasR410a2, gasR410a3],
  "gas-r407a": [gasR407a1, gasR407a2, gasR407a3],
  "gas-r124a": [gasR124a1, gasR124a2, gasR124a3],
  "gas-r227ea": [gasR227ea1, gasR227ea2, gasR227ea3],
  "can-r290": [canR2901, canR2902, canR2903],
  "can-r600": [canR6001, canR6002, canR6003],
  "can-r134a": [canR134a1, canR134a2, canR134a3],
  "can-r22": [canR221, canR222, canR223],
  "stabilizer-1kva": [stabilizer1kva1, stabilizer1kva2, stabilizer1kva3],
  "stabilizer-3kva": [stabilizer3kva1, stabilizer3kva2, stabilizer3kva3],
  "stabilizer-5kva": [stabilizer5kva1, stabilizer5kva2, stabilizer5kva3],
  "compressor-rotary": [compressorRotary1, compressorRotary2, compressorRotary3],
  "compressor-scroll": [compressorScroll1, compressorScroll2, compressorScroll3],
  "compressor-recip": [compressorRecip1, compressorRecip2, compressorRecip3],
  "indoor-unit": [indoorUnit1, indoorUnit2, indoorUnit3],
  "outdoor-unit": [outdoorUnit1, outdoorUnit2, outdoorUnit3],
};

// Placeholder wordmarks, not the companies' real logos. Replace the matching
// file under assets/catalog/brands or /customers with official artwork.
export const brandLogos = [
  { slug: "camipro", name: "Camipro", logo: brandCamipro },
  { slug: "mpcl", name: "MPCL", logo: brandMpcl },
  { slug: "floron", name: "Floron", logo: brandFloron },
  { slug: "srf", name: "SRF", logo: brandSrf },
  { slug: "value", name: "Value", logo: brandValue },
  { slug: "godrej", name: "Godrej", logo: brandGodrej },
  { slug: "copeland", name: "Copeland", logo: brandCopeland },
  { slug: "voltas", name: "Voltas", logo: brandVoltas },
  { slug: "bluestar", name: "Blue Star", logo: brandBluestar },
  { slug: "adn", name: "ADN", logo: brandAdn },
  { slug: "galaxy", name: "Galaxy", logo: brandGalaxy },
  { slug: "btali", name: "Btali", logo: brandBtali },
  { slug: "xtra-power", name: "Xtra Power", logo: brandXtraPower },
  { slug: "suntop", name: "Suntop", logo: brandSuntop },
  { slug: "brass-bliz", name: "Brass Bliz", logo: brandBrassBliz },
  { slug: "stallion", name: "Stallion", logo: brandStallion },
  { slug: "lg", name: "LG", logo: brandLg },
  { slug: "whirlpool", name: "Whirlpool", logo: brandWhirlpool },
  { slug: "indigo", name: "Indigo", logo: brandIndigo },
  { slug: "microtek", name: "Microtek", logo: brandMicrotek },
  { slug: "taparia", name: "Taparia", logo: brandTaparia },
  { slug: "multitech", name: "Multitech", logo: brandMultitech },
  { slug: "bosch", name: "Bosch", logo: brandBosch },
  { slug: "ralli-wolf", name: "Ralli Wolf", logo: brandRalliWolf },
  { slug: "htc", name: "HTC", logo: brandHtc },
];

export const customerLogos = [
  { slug: "jindal-steel", name: "Jindal Steel", logo: customerJindalSteel },
  { slug: "jindal-power", name: "Jindal Power", logo: customerJindalPower },
  { slug: "jindal-india-power", name: "Jindal India", logo: customerJindalIndiaPower },
  { slug: "gmr", name: "GMR", logo: customerGmr },
  { slug: "jsw", name: "JSW", logo: customerJsw },
  { slug: "ge-ntpc", name: "GE–NTPC", logo: customerGeNtpc },
  { slug: "tefelab", name: "Tefelab", logo: customerTefelab },
];
